import React, { Component } from "react";
import { connect } from "react-redux";
import { enterWithId } from "../actions/auth";
import { PARTICIPANT_ID_PATTERN, parseGroup, saveProlificId, saveUserGroup } from "../helpers/experiment";

/**
 * Entry point for participants coming from Qualtrics: the link carries the
 * Qualtrics response ID, the Prolific ID and the experiment group, e.g.
 * /?qualtrics_id=R_abc123&prolific_id=5f1e...&group=2. No manual login.
 * Both IDs are required; a missing or invalid group means group 0. The
 * backend keeps the group from the participant's first entry, and that
 * stored group is the one used.
 */
class StoreEntry extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: undefined,
    };
  }

  componentDidMount() {
    const { dispatch, history, location } = this.props;
    const params = new URLSearchParams(location.search);
    const qualtricsId = (params.get("qualtrics_id") || "").trim();
    const prolificId = (params.get("prolific_id") || "").trim();
    const group = parseGroup(params.get("group"));

    if (!PARTICIPANT_ID_PATTERN.test(qualtricsId) || !PARTICIPANT_ID_PATTERN.test(prolificId)) {
      this.setState({ error: "Invalid link: a Qualtrics ID and a Prolific ID are required." });
      return;
    }

    dispatch(enterWithId(qualtricsId, prolificId, group))
      .then((user) => {
        sessionStorage.removeItem("store_countdown_start");
        saveUserGroup(parseGroup(user.userGroup));
        saveProlificId(prolificId);
        history.push("/store");
        window.location.reload();
      })
      .catch(() => {
        this.setState({ error: "Une erreur est survenue lors de l'accès à la boutique." });
      });
  }

  render() {
    const { error } = this.state;
    return (
      <div id="store-entry-page">
        {!error && <div className="store-loading">Loading...</div>}
        {error && <div className="alert alert-danger" role="alert">{error}</div>}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return {
    user,
  };
}

export default connect(mapStateToProps)(StoreEntry);
